module.exports = __webpack_public_path__ + "static/img/level-card-banner2.913e9a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/8/level-card-banner2.png
// module id = gKHr
// module chunks = 1